import React, { ReactElement, ChangeEvent } from 'react'
import {
  Questions as StyledQuestions,
  Question as StyledQuestion,
} from '../styled-components'

import TickBox from '../../../../../../input/tick-box'

interface QuizTickProps {
  correctAnswers: string[] | undefined
  answers: string[] | undefined
  onValueChange: (value: string) => void
}

function QuizTick({
  correctAnswers,
  onValueChange,
  answers,
}: QuizTickProps): ReactElement {
  return (
    <StyledQuestions>
      <StyledQuestion>
        {answers?.map((answer, index) => (
          <>
            <TickBox
              defaultChecked={correctAnswers?.includes(answer)}
              onValueChange={(event: ChangeEvent<HTMLInputElement>) => {
                onValueChange(event.target.value)
              }}
              key={index}
              id={index}
              text={answer}
            />
          </>
        ))}
      </StyledQuestion>
    </StyledQuestions>
  )
}

export default QuizTick
